import React, { useState } from "react";
import Button from "../../atoms/Button/Button";
import { Help } from "@mui/icons-material";
import Drawer from "../Drawer/Drawer";
import EditModeDoctorsReport from "../EditModeDoctorsReport/EditModeDoctorsReport";

interface TabletEditModeTutorialProps {}

const TabletEditModeTutorial = (props: TabletEditModeTutorialProps) => {
  const [isTutorialOpen, setIsTutorialOpen] = useState(false);
  return (
    <>
      <Button
        className="dui-edit-mode-tablet-tutorial-btn"
        icon={<Help />}
        type="secondary"
        onClick={() => setIsTutorialOpen(true)}
      >
        Návod na používanie
      </Button>
      <Drawer
        isOpen={isTutorialOpen}
        onClose={() => setIsTutorialOpen(false)}
        widthRefElID="dui-main-page"
        className="dui-tablet-edit-mode-tutorial"
      >
        <EditModeDoctorsReport />
      </Drawer>
    </>
  );
};

export default TabletEditModeTutorial;
